import { createBrowserRouter, Outlet } from "react-router-dom";
import Root from "../components/Root";
import Home from "../pages/Home";
import { Login } from "../pages/Login";
import Projects from "../pages/Projects";
import ProjectDetails from "../pages/ProjectDetails";
import CreateProject from "../pages/CreateProject";
import RequireActive from "../pages/RequireActive";
import { ProtectedRoute } from "../components/ProtectedRoute";
import Posts from "../pages/Posts";
import CreatePost from "../pages/CreatePost";
import Post from "../pages/Post";
import EditPost from "../pages/EditPost";
import Users from "../pages/Users";
import { Landing } from "../pages/Landing";
import { AuthProvider } from "../lib/auth";
import { Privacy } from "../pages/Privacy";
import { Terms } from "../pages/Terms";
import { Security } from "../pages/Security";
import GitHubSettings from "../pages/GitHubSettings";

// Define the router configuration
export const router = createBrowserRouter([
  {
    path: "/",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <Landing />,
      },
      {
        path: "privacy",
        element: <Privacy />,
      },
      {
        path: "terms",
        element: <Terms />,
      },
      {
        path: "security",
        element: <Security />,
      },
      {
        path: "login",
        element: (
          <AuthProvider>
            <Login />
          </AuthProvider>
        ),
      },
      {
        path: "app",
        element: <Root />,
        children: [
          {
            path: "dashboard",
            element: (
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            ),
          },
          {
            path: "require-active",
            element: <RequireActive />,
          },
          {
            path: "projects",
            children: [
              {
                index: true,
                element: (
                  <ProtectedRoute>
                    <Projects />
                  </ProtectedRoute>
                ),
              },
              {
                path: "new",
                element: (
                  <ProtectedRoute>
                    <CreateProject />
                  </ProtectedRoute>
                ),
              },
              {
                path: ":projectId",
                element: (
                  <ProtectedRoute>
                    <ProjectDetails />
                  </ProtectedRoute>
                ),
              },
            ],
          },
          {
            path: "posts",
            children: [
              {
                index: true,
                element: (
                  <ProtectedRoute>
                    <Posts />
                  </ProtectedRoute>
                ),
              },
              {
                path: "new",
                element: (
                  <ProtectedRoute>
                    <CreatePost />
                  </ProtectedRoute>
                ),
              },
              {
                path: ":postId",
                children: [
                  {
                    index: true,
                    element: (
                      <ProtectedRoute>
                        <Post />
                      </ProtectedRoute>
                    ),
                  },
                  {
                    path: "edit",
                    element: (
                      <ProtectedRoute>
                        <EditPost />
                      </ProtectedRoute>
                    ),
                  },
                ],
              },
            ],
          },
          {
            path: "users",
            element: (
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            ),
          },
          {
            path: "github",
            children: [
              {
                path: "settings",
                element: (
                  <ProtectedRoute>
                    <GitHubSettings />
                  </ProtectedRoute>
                ),
              },
              {
                path: "settings/callback",
                element: (
                  <ProtectedRoute>
                    <GitHubSettings />
                  </ProtectedRoute>
                ),
              },
              {
                path: "repositories",
                element: (
                  <ProtectedRoute>
                    <GitHubSettings />
                  </ProtectedRoute>
                ),
              },
            ],
          },
        ],
      },
    ],
  },
]);
